import "./style.less"
import {Button, Checkbox, Form, Input, Spin} from 'antd';
import {SendOutlined} from "@ant-design/icons";
import {useForm} from "antd/es/form/Form";
import TextArea from "antd/es/input/TextArea";
import {VALIDATION_MESSAGES} from "../../../../enums/validationMessages";
import {FeedbackItem} from "./types";
import emailjs from "emailjs-com";
import {useState} from "react";
import {openSuccessNotification, showErrorNotification} from "../../../../helpers/mainHelpers";


const SERVICE_ID = "service_r4lo8df"
const TEMPLATE_ID = "template_r01ki2i"
const PUBLIC_KEY = "PPNVY-Yh3PEuTMhln"

const FeedbackForm = () => {
  const [form] = useForm()
  const [isLoading, setIsLoading] = useState(false)

  const submitButtonHandler = async (formData: FeedbackItem) => {
    setIsLoading(true)
    emailjs
      .send(SERVICE_ID, TEMPLATE_ID, formData, PUBLIC_KEY)
      .then(
        () => {
          form.resetFields()
          openSuccessNotification("Ваше повідомлення надіслано!")
          setIsLoading(false)
        },
        (error) => {
          setIsLoading(false)
          showErrorNotification({message: "Сталася помилка. Спробуйте пізніше!"})
          console.error("Error:", error.text);

        }
      );

  }
  return <div className="feedback-form_wrapper">
    <Spin spinning={isLoading}>
      <div className="feedback-form__eyebrow">Напишіть нам</div>
      <div className="title">Форма зворотного зв’язку</div>
      <p className="feedback-form__description">Залиште повідомлення, і ми зв’яжемося з вами за вказаним номером.</p>
      <Form form={form} layout="vertical" className="feedback-form" onFinish={submitButtonHandler}>
        <Form.Item name="name" label="Прізвище, ініціали:"
                   rules={[{required: true, message: VALIDATION_MESSAGES.REQUIRED}]}>
          <Input name="name" size="large" placeholder="Введіть прізвище та ініціали"/>
        </Form.Item>
        <Form.Item name="phone" label="Контактний телефон:"
                   rules={[{required: true, message: VALIDATION_MESSAGES.REQUIRED}]}>
          <Input name="phone" size="large" placeholder="Введіть контактний телефон"/>
        </Form.Item>
        <Form.Item name="message" label="Текст повідомлення:"
                   rules={[{required: true, message: VALIDATION_MESSAGES.REQUIRED}]}>
          <TextArea name="message" rows={6} placeholder="Введіть текст повідомлення"/>
        </Form.Item>
        <Form.Item name="agree"
                   valuePropName="checked"
                   rules={[{required: true, message: 'Потрібна згода!'}]}>
          <Checkbox> Я погоджуюсь з обробкою персональних даних</Checkbox>
        </Form.Item>
      </Form>
      <div className="footer">
        <Button className="submit_button" type="primary" size="large" icon={<SendOutlined/>} onClick={() => {
          form.submit()
        }}>
          Надіслати повідомлення
        </Button>
      </div>
    </Spin>
  </div>
}
export default FeedbackForm
